const faqData = [
  {
    question: "How often should I visit the dentist?",
    answer:
      "It is generally recommended to visit the dentist every six months for a routine checkup and cleaning. However, your dentist may suggest more frequent visits based on your individual needs.",
  },
  {
    question: "What should I do in a dental emergency?",
    answer:
      "If you experience a dental emergency like a knocked-out tooth, severe pain, or bleeding, contact your dentist immediately. For knocked-out teeth, try to keep the tooth moist and bring it with you.",
  },
  {
    question: "Are dental X-rays safe?",
    answer:
      "Yes, dental X-rays are safe. They use minimal radiation and are crucial for detecting issues not visible during a physical exam, such as cavities between teeth or bone infections.",
  },
  {
    question: "Is teeth whitening safe?",
    answer:
      "Teeth whitening is safe when performed under professional guidance. Overuse of whitening products can damage enamel, so it’s best to consult your dentist before starting any treatment.",
  },
  {
    question: "What causes tooth sensitivity?",
    answer:
      "Tooth sensitivity is often caused by worn enamel, exposed roots, or cavities. Using toothpaste designed for sensitive teeth and avoiding very hot or cold foods can help manage it.",
  },
  {
    question: "At what age should my child first see a dentist?",
    answer:
      "Your child should visit the dentist by their first birthday or within six months of their first tooth erupting. Early visits help monitor development and prevent early dental problems.",
  },
  {
    question: "What are dental implants?",
    answer:
      "Dental implants are titanium posts surgically placed in the jawbone to act as roots for artificial teeth. They offer a permanent and natural-looking solution for missing teeth.",
  },
  {
    question: "Can crooked teeth cause health issues?",
    answer:
      "Yes. Crooked teeth can lead to jaw strain, gum disease, and difficulty cleaning, which increases the risk of cavities. Orthodontic treatment not only improves appearance but also oral health.",
  },
];

export default faqData;
